export const FIELD_NAME_FIELD_NAME = 'name';

export const CLIENT_FIELD_NAME = 'client';

export const FARM_FIELD_NAME = 'farm';

export const TEST_ID = 'fieldFormFields';
